export interface ImageDimensions {
    width: number;
    height: number;
}

export const getImageDimensions = async (url: string): Promise<ImageDimensions> => {
    if (!url) throw new Error(`Can't resolve dimensions of url ${url}`);

    const im = new Image();
    im.src = url;

    await new Promise((resolve, reject) => {
        im.onload = resolve;
        im.onerror = reject;
    });

    return {
        width: im.width,
        height: im.height,
    };
};
